import React from "react";
import styled from "styled-components";
import Hero from "src/components/Hero/Hero";
import { Table, Row, Col } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import ReactMarkdown from "react-markdown";
import TitleSection from "src/components/TitleSection/TitleSection";
import EventFinished from "src/components/EventFinished";
import CashGamesInfo from "src/components/Poker/CashGamesInfo";

const HockeyNightAtPlayground2026 = () => {
  const { t, i18n } = useTranslation();

  return (
    <HockeyNightDiv>
      <EventFinished
        scheduleKeyName="hockeyNightAtPlayground2026"
        eventType="promotion"
      />
      <Hero
        bgImage="promotions/poker/hockey-night-at-playground-2026/hockey-night-hero-image-2400x800px.jpg"
        buttonSettings={null}
        image={`promotions/poker/hockey-night-at-playground-2026/hockey-night-logo-2400x2400px-${i18n.language}.png`}
        darkenBg={0.5}
        arrowBounce={true}
        showArrow={true}
      />
      <MainContentDiv>
        <container-div>
          <TitleSection
            as={"h2"}
            title={t("poker.hockeyNightAtPlayground2026.content.title")}
            text={t("poker.hockeyNightAtPlayground2026.content.subtitle")}
            borderColor="#d59947"
          />
          <Row className="g-4 mb-0 mt-0 align-items-center" id="">
            <Col className="mt-0" xs={12} md={12}>
              <ReactMarkdown className="desc">
                {t("poker.hockeyNightAtPlayground2026.content.description")}
              </ReactMarkdown>

              <div className="splash-pot-section">
                <Row>
                  <Col className="p-0">
                    <TitleSection
                      title={t(
                        "poker.hockeyNightAtPlayground2026.content.splashPot.title",
                      )}
                      text={t(
                        "poker.hockeyNightAtPlayground2026.content.splashPot.description",
                      )}
                      borderColor="#d59947"
                      as="h4"
                    />
                  </Col>
                  <Col className="p-0">
                    <div className="stakes-table">
                      <StyledTable responsive variant="dark">
                        <thead>
                          <tr>
                            <th>
                              <ReactMarkdown>
                                {t(
                                  "poker.hockeyNightAtPlayground2026.content.splashPot.stakesTitle",
                                )}
                              </ReactMarkdown>
                            </th>
                            <th>
                              <ReactMarkdown>
                                {t(
                                  "poker.hockeyNightAtPlayground2026.content.splashPot.splashTitle",
                                )}
                              </ReactMarkdown>
                            </th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr>
                            <td>
                              <ReactMarkdown>
                                {t(
                                  "poker.hockeyNightAtPlayground2026.content.splashPot.stakes-1",
                                )}
                              </ReactMarkdown>
                            </td>
                            <td>
                              {t(
                                "poker.hockeyNightAtPlayground2026.content.splashPot.amount-1",
                              )}
                            </td>
                          </tr>
                          <tr>
                            <td>
                              <ReactMarkdown>
                                {t(
                                  "poker.hockeyNightAtPlayground2026.content.splashPot.stakes-2",
                                )}
                              </ReactMarkdown>
                            </td>
                            <td>
                              {t(
                                "poker.hockeyNightAtPlayground2026.content.splashPot.amount-2",
                              )}
                            </td>
                          </tr>
                          <tr>
                            <td>
                              <ReactMarkdown>
                                {t(
                                  "poker.hockeyNightAtPlayground2026.content.splashPot.stakes-3",
                                )}
                              </ReactMarkdown>
                            </td>
                            <td>
                              {t(
                                "poker.hockeyNightAtPlayground2026.content.splashPot.amount-3",
                              )}
                            </td>
                          </tr>
                          <tr>
                            <td>
                              <ReactMarkdown>
                                {t(
                                  "poker.hockeyNightAtPlayground2026.content.splashPot.stakes-4",
                                )}
                              </ReactMarkdown>
                            </td>
                            <td>
                              {t(
                                "poker.hockeyNightAtPlayground2026.content.splashPot.amount-4",
                              )}
                            </td>
                          </tr>
                        </tbody>
                      </StyledTable>
                    </div>
                  </Col>
                </Row>
              </div>

              <div className="splash-pot-section">
                <TitleSection
                  title={t(
                    "poker.hockeyNightAtPlayground2026.content.ticketGiveaway.title",
                  )}
                  text={t(
                    "poker.hockeyNightAtPlayground2026.content.ticketGiveaway.description",
                  )}
                  borderColor="#d59947"
                  as="h4"
                />
              </div>

              <CashGamesInfo />
            </Col>
          </Row>
        </container-div>

        <div className="rules-section">
          <container-div>
            <h4>{t("poker.hockeyNightAtPlayground2026.rules.title")}</h4>
            <ReactMarkdown>
              {t("poker.hockeyNightAtPlayground2026.rules.content")}
            </ReactMarkdown>
          </container-div>
        </div>
      </MainContentDiv>
    </HockeyNightDiv>
  );
};

const HockeyNightDiv = styled.div`
  width: 100%;
  height: auto;
  background: var(--lightblack);
  color: var(--white);
  padding-bottom: 1rem;
  text-align: center;
  .hero_image {
    padding: 2rem 2rem 4rem;
    @media (min-width: 768px) {
      padding: 3rem;
    }
    opacity: 0.9;
  }
  .small {
    text-align: center;
  }
  strong {
    color: #d59947;
  }
`;

const StyledTable = styled(Table)`
  width: 100%;
  max-width: 30rem;
  margin: 0 auto;
  th {
    background-color: var(--mutedred);
  }
  tr {
    td:first-child,
    th:first-child {
      text-align: left;
    }
  }
  th,
  td {
    padding: 0.8rem;
    p {
      margin: 0;
    }
  }
`;

const MainContentDiv = styled.div`
  padding-bottom: 1rem;
  h2:after {
    border-color: #d59947;
  }
  @media (min-width: 768px) {
    padding: 2rem 1rem 1rem;
  }
  container-div {
    background-color: var(--lightblack);
  }
  @media (min-width: 992px) {
    padding: 3rem 0;
  }
  height: auto;
  width: 100%;
  text-align: center;

  .splash-pot-section {
    background-color: #000;
    margin: 2rem 0;
  }

  .stakes-table {
    padding: 1.5rem;
    margin: 1rem 0;
    border-radius: 8px;

    h4 {
      color: #d59947;
      font-weight: 700;
      text-transform: uppercase;
      text-align: center;
      padding: 15px;
      font-size: 20px;
      margin: 0 0 10px 0;
    }
  }

  .rules-section {
    background-color: #111;
    margin-top: 40px;
    padding: 40px 0;
    text-align: left;

    container-div {
      background-color: #000;
      max-width: 1440px;
      margin: 0 auto;
      padding: 1rem 2rem 2rem;

      h4 {
        color: #999;
        font-weight: 700;
        font-size: 30px;
        text-transform: uppercase;
        text-align: center;
        padding: 15px;
        margin: 5px 0 20px 0;
      }
    }
  }

  .rules-section li {
    white-space: normal;
  }
  ul {
    list-style: none;
    white-space: normal;
    p {
      margin: 10px 0;
    }
  }
  ol ul {
    margin: 0.15rem 0 0;
    padding-left: 1.25rem;
    li {
      margin: 0;
      line-height: 1.45;
    }
  }
  .row {
    display: flex;
    justify-content: space-between;
    max-width: 1200px;
    margin: 0 auto;
    position: relative;
  }
`;

export default HockeyNightAtPlayground2026;
